<template>
    <vs-chip class="ag-grid-cell-chip" :color="chipColor(status)">
      <span>{{ status }}</span>
    </vs-chip>
</template>

<script>
export default {
  name: 'CellRendererStatus',
  props: ['status'],
  computed: {
    chipColor () {
      return (value) => {
        if (value === 'Commande transferée') return 'success'
        else if (value === 'En attente de validation') return 'danger'
        else if (value === 'En edition') return 'warning'
        else return 'primary'
      }
    }
  }
}
</script>

<style lang="scss" scpoped>
.ag-grid-cell-chip {
  &.vs-chip-success {
    background: rgba(var(--vs-success),.15);
    color: rgba(var(--vs-success),1) !important;
    font-weight: 500;
  }
  &.vs-chip-warning {
    background: rgba(var(--vs-warning),.15);
    color: rgba(var(--vs-warning),1) !important;
    font-weight: 500;
  }
  &.vs-chip-danger {
    background: rgba(var(--vs-danger),.15);
    color: rgba(var(--vs-danger),1) !important;
    font-weight: 500;
  }
}
</style>
